import React, { useContext, useEffect, useState } from 'react';
import Root from "Views/Root";
import { NavigationHistoryProvider } from 'Navigation/NavigationHistoryProvider';
import { useLocation } from 'react-router-dom';
import { HubContext } from 'Redux/Context/context';
import { VegaFlex, VegaAppHeaderButton, VegaLoadingIndicator } from "@heartlandone/vega-react";
import { _fetch } from 'Chore/Request';
import { PATH } from 'Chore/Apis';

import { toggleGlobalModalAction, setUserInfoAction, setDashboardBasicDataAction, setActivityCategoriesAction } from 'Redux/Actions/actions';
import './App.css';

const { GET_USER_INFO, GET_DASHBOARD_BASIC_DATA, GET_ACTIVITY_CATEGORIES } = PATH;

function App() {
  const { globalModalState, globalModalDispatch, userInfoState, userInfoDispatch, dashboardBasicDataStateDispatch, activityCategoriesDispatch } = useContext(HubContext);
  const _toggleModal = (isShow = false) => {
    globalModalDispatch(toggleGlobalModalAction({isShow}));
  }
  const location = useLocation();
  const [isShowAuthor, setIsShowAuthor] = useState(false);


  useEffect(() => {
    _toggleModal(true);
    const fetchUser =  _fetch({
      api: GET_USER_INFO,
    });
    const fetchBasicData = _fetch({
      api: GET_DASHBOARD_BASIC_DATA,
    })
    const fetchActivityCategories = _fetch({
      api: GET_ACTIVITY_CATEGORIES,
    })
    Promise.all([fetchUser, fetchBasicData, fetchActivityCategories]).then((responses) => {
      if(responses[0].code === 2200){
        const userInfo = responses[0].payload;
        userInfoDispatch(setUserInfoAction({userInfo: {
            ...userInfo
        }}));
          }
      if(responses[1].code === 2200){
        const basicData = responses[1].payload;
        dashboardBasicDataStateDispatch(
          setDashboardBasicDataAction(basicData)
        )
      }
      if(responses[2].code === 2200){
        const activityCategories = responses[2].payload;
        activityCategoriesDispatch(
          setActivityCategoriesAction(activityCategories)
        )
      }
    }).finally(() => {
      _toggleModal();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setIsShowAuthor(location.pathname.includes('activityInfoForm'));
  }, [location]);

  return (
    <>
      <VegaFlex id='global-modal' className={`${globalModalState.isShow ? '' : 'display-none'} top-floor w-full h-full`} justifyContent="center" alignItems="center" style={{position: 'fixed'}}>
        <VegaLoadingIndicator mode={`indeterminate`}/>
      </VegaFlex>
      <div id="app-root" style={{ width: '100%', height: '100vh' }} className="box-border p-x-32">
        <VegaFlex justifyContent="space-between" alignItem="center" className="p-t-32 p-b-24" style={{ height: 68 }}>
          <VegaFlex alignItem="center" gap={'size-12'} direction={'col'}>
            <span className="f-size-28 f-weight-700 line-height-36">Activity Hub</span>
            {
              isShowAuthor && <span className="f-size-18 f-weight-700 line-height-24 font-light-text-color-secondary">Created by {userInfoState?.userInfo?.name}</span>
            }
          </VegaFlex>
          <VegaAppHeaderButton
            label={userInfoState?.userInfo?.name}
            avatar={{
              src: userInfoState.userInfo.avatar,
              fallbackText: userInfoState?.userInfo?.name
            }}
            dropdown={{
              "source": [
                {
                  "key": "sign-out",
                  "label": "Sign Out"
                }
              ],
              matchTargetWidth: true
            }}
            onVegaDropdownClick = {(e) => {
              if (e.detail === "sign-out") {
                sessionStorage.removeItem('token');
                window.location.href = `${process.env.REACT_APP_PROXY_TARGET_URL}/logout`;
              }
            }}
          />
        </VegaFlex>
        <NavigationHistoryProvider>
          <Root />
        </NavigationHistoryProvider>
        <div style={{
          paddingTop: 64,
          paddingBottom: 20
        }}></div>
      </div>
    </>
  );
}

export default App;
